// NGRX
import { Action } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { CompanyNotificationModel } from '../../../notification/models/company-notification.model';

export enum CompanyNotificationActionTypes {
  CompanyNotificationsPageRequested = '[CompanyNotifications List Page] CompanyNotifications Page Requested',
  CompanyNotificationsPageLoaded = '[CompanyNotifications API] CompanyNotifications Page Loaded',
  CompanyNotificationsPageCancelled = '[CompanyNotifications API] CompanyNotifications Page Cancelled',
  CompanyNotificationsPageToggleLoading = '[CompanyNotifications] CompanyNotifications Page Toggle Loading',
  CompanyNotificationActionToggleLoading = '[CompanyNotifications] CompanyNotifications Action Toggle Loading',
  ThrowCompanyNotificationError = '[CompanyNotifications] Throw CompanyNotification Error',
  FireCompanyNotificationSuccess = '[CompanyNotifications] Fire CompanyNotification Success',
}

export class CompanyNotificationsPageRequested implements Action {
  readonly type = CompanyNotificationActionTypes.CompanyNotificationsPageRequested;
  constructor(public payload: { page: QueryParamsModel; id: number; level }) {}
}

export class CompanyNotificationsPageLoaded implements Action {
  readonly type = CompanyNotificationActionTypes.CompanyNotificationsPageLoaded;
  constructor(
    public payload: {
      companyNotifications: CompanyNotificationModel[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class CompanyNotificationsPageCancelled implements Action {
  readonly type = CompanyNotificationActionTypes.CompanyNotificationsPageCancelled;
}

export class CompanyNotificationsPageToggleLoading implements Action {
  readonly type = CompanyNotificationActionTypes.CompanyNotificationsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class CompanyNotificationActionToggleLoading implements Action {
  readonly type = CompanyNotificationActionTypes.CompanyNotificationActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowCompanyNotificationError implements Action {
  readonly type = CompanyNotificationActionTypes.ThrowCompanyNotificationError;
  constructor(public payload: { error: any }) {}
}

export class FireCompanyNotificationSuccess implements Action {
  readonly type = CompanyNotificationActionTypes.FireCompanyNotificationSuccess;
  constructor(public payload: { action_type: string }) {}
}

export type CompanyNotificationActions =
  | CompanyNotificationsPageRequested
  | CompanyNotificationsPageLoaded
  | CompanyNotificationsPageCancelled
  | CompanyNotificationsPageToggleLoading
  | CompanyNotificationActionToggleLoading
  | ThrowCompanyNotificationError
  | FireCompanyNotificationSuccess;
